function ErrorComponent({ message }) {
  return (
    <main>
      <p>{message}</p>
    </main>
  );
}

export default ErrorComponent;
